<div class="game-replay__container" *transloco="let t; prefix: 'pages.game-component'">
  <app-nav-button icon="close" (clickEvent)="onCloseClicked()" class="game-replay__back-button" />
  @if (gameInterfaceState === GameInterfaceState.ReplayReady) {
    <div class="game-replay__content">
      <div class="game-replay__prize">
        <div [ngStyle]="prizeStyles | theme" class="game-replay__prize-content">
          <span>{{ t("prize") }} </span>
          @if (reward?.primary?.icon && reward?.primary?.iconPosition === "start") {
            <app-currency-icon [icon]="reward!.primary.icon!" sizeCss="--icon-medium" />
          }
          {{ reward?.primary?.text }}
          @if (reward?.primary?.icon && reward?.primary?.iconPosition === "end") {
            <app-currency-icon [icon]="reward!.primary.icon!" sizeCss="--icon-medium" />
          }
          @if (hasSecondaryCurrency) {
            <span class="secondary-span">
              {{ "(" }}
              <span class="secondary-icon-span">
                @if (reward?.secondary?.icon && reward?.secondary?.iconPosition === "start") {
                  <app-currency-icon [icon]="reward!.secondary.icon!" sizeCss="--icon-medium" />
                }
                {{ reward?.secondary?.text }}
                @if (reward?.secondary?.icon && reward?.secondary?.iconPosition === "end") {
                  <app-currency-icon [icon]="reward!.secondary.icon!" sizeCss="--icon-medium" />
                }
              </span>
              {{ ")" }}
            </span>
          }
        </div>
      </div>
      <div class="game-replay__room">
        <div [ngStyle]="roomStyles | theme">
          <span>{{ roomId }}</span>
        </div>
      </div>
    </div>
  }
</div>
